import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Alert } from "@mui/material";
import {
  Assignment as TaskIcon,
  CheckCircle as CompletedIcon,
  PlayArrow as InProgressIcon,
  Schedule as TodoIcon,
} from "@mui/icons-material";

// LAGE Dashboard React components
import MDBox from "../../components/MDBox";
import ComplexStatisticsCard from "../../components/Cards/StatisticsCard";
import DashboardLayout from "../../layouts/DashboardLayout";
import TodoList from "../../components/TodoList";

const Dashboard = () => {
  const user = useSelector((state) => state.auth.user);
  const [error, setError] = useState(null);

  return (
    <DashboardLayout>
      <MDBox py={3}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {/* Todo List Section */}
        <MDBox mt={4.5}>
          <TodoList />
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
};

export default Dashboard;
